require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-the-world-bank-support-lgbtqi-individuals-in.json") })
        }
      }, "path---en-us-update-how-can-the-world-bank-support-lgbtqi-individuals-in");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-the-world-bank-support-lgbtqi-individuals-in!./.cache/json/en-us-update-how-can-the-world-bank-support-lgbtqi-individuals-in.json
// module id = 726
// module chunks = 231608221292675